export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7434.4d1996ba.jpg";